import { render, staticRenderFns } from "./AddBasicCampaignPrice.vue?vue&type=template&id=a6f9e1f8"
import script from "./AddBasicCampaignPrice.vue?vue&type=script&lang=js"
export * from "./AddBasicCampaignPrice.vue?vue&type=script&lang=js"
import style0 from "./AddBasicCampaignPrice.vue?vue&type=style&index=0&id=a6f9e1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports